var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lk-cascader',{attrs:{"data":_vm.goodsTypes,"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"on-change":_vm.handleChange},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})}
var staticRenderFns = []

export { render, staticRenderFns }